import { Button, Card, Skeleton } from "@chef/components";
import {
  CurrencyWrapper as Currency,
  PreferencesDetails,
} from "@chef/smart-components";
import { isConceptPreference, isTastePreference } from "@chef/helpers";
import { usePreferencesQuery } from "@chef/state-management";

import { OhSnap } from "@chef/icons/symbol";
import { BRAND_PATHS } from "@chef/constants";

import { useMySubscriptionMealbox } from "../../hooks/useMySubscriptionMealbox";

import { intl } from "./YourMealbox.Intl";

export const YourMealbox = () => {
  const { isLoading: isLoadingPreferences } = usePreferencesQuery();

  const {
    meals,
    portions,
    mealboxPrice,
    preferences: myPreferences,
    isLoading: isLoadingBilling,
  } = useMySubscriptionMealbox();

  const pricePerPortion = mealboxPrice / (portions * meals);

  const tastePreferences = myPreferences.filter(isTastePreference);

  const conceptPreferences = myPreferences.filter(isConceptPreference); //We allow for multiple concept preferences in OneSub.

  const isLoading = isLoadingPreferences || isLoadingBilling;
  return (
    <Card className="relative flex flex-col gap-3" id="mealbox-card">
      <h2 className="text-xl">
        <strong>{intl.YOUR_MEALBOX}</strong>
      </h2>

      {isLoading && (
        <div>
          <div className="flex flex-col gap-2 mt-4">
            <Skeleton width={16} />
            <Skeleton width={32} />
            <Skeleton width={16} />
          </div>

          <div className="flex flex-col gap-2 mt-4">
            <Skeleton width={16} />
            <Skeleton width={32} />
            <Skeleton width={16} />
          </div>
        </div>
      )}

      {!isLoading && (
        <div>
          <div className="text-sm">
            <p>
              <strong>{intl.SIZE}:</strong>
            </p>

            <strong>{intl.FORMAT_PORTIONS_MEALS({ portions, meals })}</strong>

            <p>
              {intl.PRICE_PER_PORTION}: <Currency>{pricePerPortion}</Currency>
            </p>
          </div>

          <div className="mt-3 text-sm">
            <p>
              <strong>{intl.PREFERENCES}:</strong>
            </p>

            <PreferencesDetails
              conceptPreferences={conceptPreferences}
              tastePreferences={tastePreferences}
            />
          </div>
        </div>
      )}
      <Button
        href={BRAND_PATHS.MEALBOX_PREFERENCE}
        small
        primary
        className="self-start mt-4 text-sm"
      >
        {intl.CHANGE_MEALBOX}
      </Button>
      <OhSnap className="absolute text-3xl right-6" />
    </Card>
  );
};
